import { Bot, Calculator, BrainCircuit, Code, Pencil, GraduationCap, Puzzle, Dna, Rocket, Gift } from "lucide-react";

export const NAV_LINKS = [
  { href: "/", label: "Home" },
  { href: "/about", label: "About Us" },
  { href: "/blog", label: "Blog" },
  { href: "/programs", label: "Programs" },
  { href: "/offers", label: "Special Offers" },
  { href: "/global-reach", label: "Global Reach" },
  { href: "/testimonials", label: "Testimonials" },
  { href: "/gallery", label: "Gallery" },
  { href: "/faq", label: "FAQs" },
  { href: "/contact", label: "Contact Us" },
];

export const PROGRAMS = [
  {
    slug: "abacus",
    title: "Abacus",
    ageGroup: "6-15 Years",
    icon: Calculator,
    description: "Master mental arithmetic and boost concentration with our comprehensive Abacus program.",
    curriculum: ["Introduction to Abacus", "Basic Addition & Subtraction", "Advanced Multiplication & Division", "Decimal and Negative Numbers", "LCM", "HCF", "%", "Negative Addition Subtraction"],
    skills: ["Mental Calculation", "Concentration", "Memory Retention", "Speed & Accuracy"],
  },
  {
    slug: "robotics",
    title: "Robotics",
    ageGroup: "8+ Years",
    icon: Bot,
    description: "Build and program robots, and dive into the world of automation and engineering.",
    curriculum: ["Basics of Robotics", "Sensor Integration", "Motor Control", "Autonomous Robot Programming"],
    skills: ["Problem Solving", "Logical Thinking", "Creativity", "STEM Skills"],
  },
  {
    slug: "ai",
    title: "Artificial Intelligence",
    ageGroup: "9+ Years",
    icon: BrainCircuit,
    description: "Explore the fundamentals of AI, machine learning, and create intelligent applications.",
    curriculum: ["Introduction to AI", "Machine Learning Concepts", "Neural Networks", "AI Project Development"],
    skills: ["Analytical Thinking", "Data Analysis", "Programming", "Innovation"],
  },
  {
    slug: "vedic-maths",
    title: "Vedic Maths",
    ageGroup: "10+ Years",
    icon: Rocket,
    description: "Learn ancient high-speed calculation techniques to solve complex math problems in seconds.",
    curriculum: ["16 Sutras of Vedic Maths", "High-Speed Addition & Multiplication", "Algebraic Applications", "Square and Cube Roots"],
    skills: ["Speed Calculation", "Mathematical Intuition", "Confidence", "Problem Solving"],
  },
  {
    slug: "handwriting-improvement",
    title: "Handwriting Improvement",
    ageGroup: "6+ Years",
    icon: Pencil,
    description: "Develop neat, legible, and beautiful handwriting with our structured improvement course.",
    curriculum: ["Posture and Grip", "Letter Formation Drills", "Cursive Writing Techniques", "Speed Writing Practice"],
    skills: ["Fine Motor Skills", "Legibility", "Presentation", "Patience"],
  },
  {
    slug: "coding",
    title: "Coding",
    ageGroup: "10+ Years",
    icon: Code,
    description: "Learn to code and create your own games, websites, and applications.",
    curriculum: ["Programming Fundamentals", "Web Development (HTML, CSS, JS)", "Game Development", "Python Programming"],
    skills: ["Logical Reasoning", "Problem Solving", "Creativity", "Computational Thinking"],
  },
  {
    slug: "advanced-maths",
    title: "Advanced Maths",
    ageGroup: "10+ Years",
    icon: GraduationCap,
    description: "Tackle advanced mathematical concepts and prepare for competitive exams.",
    curriculum: ["Advanced Algebra", "Trigonometry", "Calculus Basics", "Olympiad Problem Solving"],
    skills: ["Critical Thinking", "Abstract Reasoning", "Analytical Skills", "Exam Preparedness"],
  },
  {
    slug: "brain-development-activities",
    title: "Brain Development Activities",
    ageGroup: "8+ Years",
    icon: Puzzle,
    description: "Engage in fun activities and puzzles designed to enhance cognitive abilities.",
    curriculum: ["Logic Puzzles", "Memory Games", "Creative Thinking Exercises", "Spatial Reasoning Tasks"],
    skills: ["Cognitive Flexibility", "Working Memory", "Problem Solving", "Creativity"],
  },
  {
    slug: "dmit-report",
    title: "DMIT Report",
    ageGroup: "3+ Years",
    icon: Dna,
    description: "Discover innate talents and learning styles through Dermatoglyphics Multiple Intelligence Test.",
    curriculum: ["Fingerprint Analysis", "Brain Lobe Functions", "Multiple Intelligence Profiling", "Personalized Counseling"],
    skills: ["Self-Awareness", "Career Guidance", "Personalized Learning", "Strength Identification"],
  },
  {
    slug: "memory-program",
    title: "Memory Program",
    ageGroup: "8+ Years",
    icon: BrainCircuit,
    description: "Learn powerful techniques to improve memory retention and recall for academics and life.",
    curriculum: ["Mnemonic Techniques", "Visualization Methods", "Mind Mapping", "Information Recall Strategies"],
    skills: ["Enhanced Memory", "Faster Learning", "Academic Performance", "Concentration"],
  }
];

export const STATS = [
    { value: "1000+", label: "Happy Students" },
    { value: "15+", label: "Expert Teachers" },
    { value: "15+", label: "Countries Served" },
];

export const COUNTRIES = [
    "India", "Dubai", "USA", "Hong Kong", "Saudi Arabia", "Australia", 
    "East Africa", "Norway", "Germany", "Poland", "UK", "Canada", "Netherland", "Singapore", "Malaysia"
];

export const IMAGE_TESTIMONIALS = [
    { imageUrl: "https://i.postimg.cc/T1DW2KK2/Yashika-testimonials.jpg" },
    { imageUrl: "https://i.postimg.cc/76TR3yhN/Rohan-Testimonials.jpg" },
    { imageUrl: "https://i.postimg.cc/bNP5tWh6/He-testimonials.jpg" },
    { imageUrl: "https://i.postimg.cc/ZqWsmhrX/Shourya-testimonials.jpg" },
    { imageUrl: "https://i.postimg.cc/fyfBCWN8/Vivan-testimonials.jpg" },
    { imageUrl: "https://i.postimg.cc/tCDBVgD1/Shourya_testimonials_UBG.jpg" },
    { imageUrl: "https://i.postimg.cc/SNVgzKVj/Kids_testimonials.jpg" },
    { imageUrl: "https://i.postimg.cc/rp4GgyGz/testimonials-UBG.jpg" },
    { imageUrl: "https://i.postimg.cc/tCghwNtH/testimonials_UBG.jpg" },
    { imageUrl: "https://i.postimg.cc/RV0cyL1Y/Rohan_testimonials_UBG.jpg" },
    { imageUrl: "https://i.postimg.cc/gk0vQHqW/Arayadha_testimonials_UBG.jpg" },
    { imageUrl: "https://i.postimg.cc/mkktX8xm/testimonials_UBG.jpg" },
    { imageUrl: "https://i.postimg.cc/4yymLBCb/testimonials_U_B_G.jpg" },
    { imageUrl: "https://i.postimg.cc/rssKnQ6g/testimonials.jpg" },
    { imageUrl: "https://i.postimg.cc/J00G6Pwx/Arayadha_testimonials.jpg" }
];

export const VIDEO_TESTIMONIALS = [
    { videoUrl: "https://www.youtube.com/embed/VdmCbnXD01g" },
    { videoUrl: "https://www.youtube.com/embed/bLo1lcyms8s" },
    { videoUrl: "https://www.youtube.com/embed/DGW4_Cy6Qvs" },
    { videoUrl: "https://www.youtube.com/embed/qwpnQYYj7lg" },
    { videoUrl: "https://www.youtube.com/embed/XpTRPPsaaNw" },
    { videoUrl: "https://www.youtube.com/embed/Wmw6PNMPMi0" },
    { videoUrl: "https://www.youtube.com/embed/yGU4gw0uZbU" },
];

export const GALLERY_IMAGES = [
    "https://i.postimg.cc/zvPJG59S/Aadhya-Gallery-Image.jpg",
    "https://i.postimg.cc/nrLFxMw9/Aaradhya-Gallery-Image.jpg",
    "https://i.postimg.cc/4dPfjpwG/Aarya-Gallery-Image.jpg",
    "https://i.postimg.cc/T2k29qpY/Abinav-Gallery-Image.jpg",
    "https://i.postimg.cc/SRtyxqwn/Adhij-Gallery-Image.jpg",
    "https://i.postimg.cc/VvNfw5Z3/Advit-Geetanshi-Gallery-Image.jpg",
    "https://i.postimg.cc/ZnDT5Z1v/Ananya-Gallery-Image.jpg",
    "https://i.postimg.cc/j5tq8MHZ/Ananya-Trophy-Image.jpg",
    "https://i.postimg.cc/kGhng9kc/Divyam-Gallery-Image.jpg",
    "https://i.postimg.cc/KjYGb4sM/Hardik-Gallery-Image.jpg",
    "https://i.postimg.cc/3R18z297/Harshit-Gallery-Image.jpg",
    "https://i.postimg.cc/7hLH4bQb/Jeena-Gallery-Image.jpg",
    "https://i.postimg.cc/V6gf2XgH/Jeena-Trophy-Image.jpg",
    "https://i.postimg.cc/6q19pwDR/Kanishak-Gallery-Image.jpg",
    "https://i.postimg.cc/Znqbm0Dq/Kanishka-Gallery-Image.jpg",
    "https://i.postimg.cc/wv2qnD2c/Kanishka-Trophy-Image.jpg",
    "https://i.postimg.cc/tJgqb7vw/Kavya.jpg",
    "https://i.postimg.cc/T1HR3GZh/Keshar-Gallery-Image.jpg",
    "https://i.postimg.cc/vTSQZMpB/Krit-Gallery-Image.jpg",
    "https://i.postimg.cc/9XxXptrh/Nidhi-Gallery-Image.jpg",
    "https://i.postimg.cc/1XY93PLD/Pihu-Gallery-Image.jpg",
    "https://i.postimg.cc/D0Y2wFtP/Pratyash-Gallery-Image.jpg",
    "https://i.postimg.cc/MT56g15F/Pratyash-Trophy-Image.jpg",
    "https://i.postimg.cc/zvfzN3PK/Prisha-Gallery-Image.jpg",
    "https://i.postimg.cc/Rh0Smqbt/Rian-Gallery-Image.jpg",
    "https://i.postimg.cc/5ykx21ZT/Ridhima-Gallery-Image.jpg",
    "https://i.postimg.cc/T2k29qpd/Rishit-Gallery-Image.jpg",
    "https://i.postimg.cc/GtpLR9Sm/Riyansh-Gallery-Image.jpg",
    "https://i.postimg.cc/BbvS3twW/Rohan-Gallery-Image.jpg",
    "https://i.postimg.cc/nrwHhZ6m/Shaury-Gallery-Image.jpg",
    "https://i.postimg.cc/769HjS9N/Shaury-Trophy-Image.jpg",
    "https://i.postimg.cc/j2jxTCkd/Shaurya-Gallery-Image.jpg",
    "https://i.postimg.cc/T1PdxhHv/Shivam-Gallery-image.jpg",
    "https://i.postimg.cc/ydj120jy/Shivan-Trophy-Image.jpg",
    "https://i.postimg.cc/k4sJLWsc/Shreyas-Trophy-Image.jpg",
    "https://i.postimg.cc/SQZQr7Jx/Siddhi-Gallery-Image.jpg",
    "https://i.postimg.cc/JnxrSjxv/Tanmay-Gallery-Image.jpg",
    "https://i.postimg.cc/gJsz13st/Tanmay-Trophy-Image.jpg",
    "https://i.postimg.cc/qqZkv09b/Veda-Gallery-Image.jpg",
    "https://i.postimg.cc/j2ksSKG9/Veer-Gallery-Image.jpg",
    "https://i.postimg.cc/vTSQZMpV/Yashi-Gallery-Image.jpg",
    "https://i.postimg.cc/sXGBpCSN/Utkarsh,_Mumbai.jpg",
    "https://i.postimg.cc/pd6hhL95/Tanushmay_,_Mumbai.jpg",
    "https://i.postimg.cc/HLhcckJS/Vihaan_,_Mumbai.jpg",
    "https://i.postimg.cc/YSsGGC4d/Parth_,_Mumbai.jpg",
    "https://i.postimg.cc/4yCYP2Qd/Priyansh_,_Pune.jpg",
    "https://i.postimg.cc/prNmCcJV/Aadya_,_Amravati.jpg",
    "https://i.postimg.cc/wBGyyjtc/Ishan_,_Norway.jpg",
    "https://i.postimg.cc/hG5zztJ1/Shravani,_Norway.jpg",
    "https://i.postimg.cc/QMy99dB2/Anvika,_Norway.jpg",
    "https://i.postimg.cc/3NMk1fF3/Samarth,_Mumbai.jpg",
    "https://i.postimg.cc/DZ4Wq3Lf/Aryan_,_Hydrabad.jpg",
    "https://i.postimg.cc/ZqMBB59X/Anay,_USA.jpg",
    "https://i.postimg.cc/hG5zztJH/Jenisha,_Norway.jpg",
    "https://i.postimg.cc/0NBMMy6G/Harman,_Delhi.jpg",
    "https://i.postimg.cc/XJBZw6FQ/Aryan,_Mumbai.jpg",
    "https://i.postimg.cc/tgMZZ41S/Aakrish_,_Delhi.jpg",
    "https://i.postimg.cc/bJSGQfb4/Abaan,_East_Africa.jpg",
    "https://i.postimg.cc/fbrttR3v/Abhista,_Arohi_from_Norway.jpg",
    "https://i.postimg.cc/pT59DMzP/Abhyuday,_Delhi.jpg",
    "https://i.postimg.cc/26Lq4NhD/Umar,_Dubai.jpg",
    "https://i.postimg.cc/tTn1hGWy/Rajveer,_Mumbai.jpg",
    "https://i.postimg.cc/WzRd8Yw4/Dhruv_,_USA.jpg",
    "https://i.postimg.cc/903DbgYQ/Vihaana,_Norway.jpg",
    "https://i.postimg.cc/hG5zztJ5/Shaurya,_Norway.jpg",
    "https://i.postimg.cc/G2TBknGH/Jui,_Norway.jpg",
    "https://i.postimg.cc/NFhKDCkB/Advaith,_Norway.jpg",
    "https://i.postimg.cc/26Lq4NvM/Kartikey,_Delhi.jpg"
];

export const FAQ_DATA = {
    general: [
        {
            q: "How do your programs balance with regular school academics?",
            a: "Our programs are designed to complement school curriculum. They enhance cognitive skills like concentration, memory, and logical thinking, which directly benefit academic performance."
        },
        {
            q: "Are the instructors certified?",
            a: "Yes, all our instructors are certified and undergo rigorous training. They are experts passionate about teaching children."
        },
        {
            q: "Do you offer live classes or recorded sessions?",
            a: "We primarily offer live, interactive online classes to ensure personalized attention and real-time doubt clearing."
        },
    ],
    "abacus-vedic-maths": [
        {
            q: "What is the right age to start Abacus?",
            a: "The ideal age to start Abacus training is between 6 and 15 years, when a child's brain is highly receptive to new cognitive skills."
        },
        {
            q: "How much practice is required for Vedic Maths?",
            a: "We recommend about 15-20 minutes of daily practice. Consistency is key to mastering these high-speed techniques."
        },
    ],
    "coding-robotics-ai": [
        {
            q: "My child has no prior coding experience. Can they join?",
            a: "Absolutely! Our courses are designed for beginners, starting with the basics and building concepts step-by-step."
        },
        {
            q: "What programming languages are taught?",
            a: "We cover Scratch for beginners, and Python, HTML/CSS, and JavaScript for advanced learners."
        }
    ],
    technical: [
        {
            q: "What are the technical requirements?",
            a: "Students need a stable internet connection, a computer with a webcam, and a quiet space for live classes."
        },
        {
            q: "Will my child receive a certificate?",
            a: "Yes, upon successful completion, students receive a globally valid certificate acknowledging their achievements."
        }
    ]
}

export const SOCIAL_LINKS = {
    facebook: "https://www.facebook.com/share/1AY696LYGh/",
    instagram: "https://www.instagram.com/upbeatbraingame.abacus",
    whatsapp: "https://wa.me/917517359659",
};
